import api from "@/plugins/api";
const PATH = "/opink-consent-purposes";
/**
 * Lists the consent purpose catalogue from the BFF.
 *
 * The `api` plugin interceptor already unwraps the `ApiResponse<T>` envelope,
 * so `response.data` is the payload directly (same pattern as
 * consentMatrixService.ts).
 */
export async function listConsentPurposes() {
    const response = await api.get(PATH, { unwrapEnvelope: true });
    return response.data;
}
/**
 * Creates a new consent purpose on the BFF and returns it as persisted.
 */
export async function createConsentPurpose(body) {
    const response = await api.post(PATH, body, { unwrapEnvelope: true });
    return response.data;
}
/**
 * Updates the translations of an existing consent purpose (identified by code).
 */
export async function updateConsentPurpose(code, body) {
    const response = await api.put(`${PATH}/${encodeURIComponent(code)}`, body, { unwrapEnvelope: true });
    return response.data;
}
/**
 * Toggles the active state of a consent purpose (identified by code).
 */
export async function setConsentPurposeActive(code, isActive) {
    const response = await api.patch(`${PATH}/${encodeURIComponent(code)}/active`, { isActive }, { unwrapEnvelope: true });
    return response.data;
}
/**
 * Deletes a consent purpose (identified by code).
 */
export async function deleteConsentPurpose(code) {
    await api.delete(`${PATH}/${encodeURIComponent(code)}`, { unwrapEnvelope: true });
}
